import React from 'react'
import FlightsRecentSearchCard from './FlightsRecentSearchCard'
import BundleHugWithBanner from './BundleHugWithBanner'
import { PackageSearchParamsType, FlyRecentSearchData } from '../types'
import {
  fireOnBundleNowClickEvent,
  fireFlightsOnContinueClickEvent
} from '../GA4Helpers'

export default function FlightRecentSearchWithBanner({
  searchData,
  packageSearchParams
}: {
  searchData: FlyRecentSearchData
  packageSearchParams: PackageSearchParamsType
}) {
  return (
    <FlightsRecentSearchCard
      searchData={searchData}
      onContinueSearchClick={fireFlightsOnContinueClickEvent}
    >
      <BundleHugWithBanner
        packageSearchParams={packageSearchParams}
        onBundleNowClick={fireOnBundleNowClickEvent}
      />
    </FlightsRecentSearchCard>
  )
}
